import { TEMPLATE_DEPLOYMENTS_COLUMN_ID } from "../constants";
import TemplateDeploymentsRowActionsCell from "./RowActionsCell";
import TemplateDeploymentsNameCell from "./NameCell";
import TemplateDeploymentsVersionCell from "./VersionCell";
import TemplateDeploymentsStatusCell from "./StatusCell";
import TemplateDeploymentsCreatedAtCell from "./CreatedAtCell";

export const TEMPLATE_DEPLOYMENTS_TABLE_CELLS = {
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.NAME]: TemplateDeploymentsNameCell,
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.VERSION]: TemplateDeploymentsVersionCell,
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.STATUS]: TemplateDeploymentsStatusCell,
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.CREATED_AT]: TemplateDeploymentsCreatedAtCell,
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.DROPDOWN]: TemplateDeploymentsRowActionsCell,
};
